import RestApi from './../../api/automation-api-client'
const srvcEndpoint = '/leader-report-cards'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  get: async (id, req, opts) => RestApi.request('GET', srvcEndpoint, id, req, opts),
  drill: async (id, metric_name) =>
    RestApi.request('GET', srvcEndpoint, {}, { endpoint: `/${id}/drill/${metric_name}` }),
  download: async (id, metric_name) =>
    RestApi.request('POST', srvcEndpoint, { id }, { endpoint: `/download/${metric_name}` }),
  getLastYearReport: async (id, type, req, opts) =>
    RestApi.request('GET', srvcEndpoint, req, {
      endpoint: `/${id}/${type}/getLastYearReport`,
    }),
}
